module.exports = __webpack_public_path__ + "img/sms.d16f751.png";